import SeeMoreTile from './SeeMoreTile'

export default SeeMoreTile
